import * as React from 'react'
import { Pagination } from '@amzn/dvui/dist/Pagination'
import { QueryParameters } from 'DVWebNodeUtils'
import { int } from '../../utils/utils'
import { paginator } from '../../utils/paginator'
import { detailPagePath } from '../../utils/url'
import { StringId } from '../localizer/stringId'
import { collectionTypes, CollectionType } from './collectionTypes'
import { withLocalization, LocalizerProps } from '../localizer/localizer'
import { IDetailPageState } from '../../reducers'
import { connect } from 'react-redux'
import {
  sanitizedRequestContextSelector,
  IRequestContext
} from '../../selectors/requestContext'

export const DEFAULT_PAGE_SIZE = 200
export const DEFAULT_TOTAL_ITEMS_LIMIT = 10000

type IStateProps = {
  requestContext: IRequestContext
  pageTitleId: string
}

type Params = {[key: string]: string}
const paginationParams: Params = collectionTypes.reduce((params, type) => (
  { ...params, [type]: `${type}From`}
), {})

const getCurrentOffsets = (parameters: QueryParameters) => (
  Object.keys(paginationParams).reduce((params, type) => {
    const paramName = paginationParams[type]
    if (paramName && parameters[paramName]) {
      params[paramName] = parameters[paramName][0] as string
    }
    return params
  }, {} as Params)
)

export const getCollectionCurrentOffset = (parameters: QueryParameters, collectionType: CollectionType): number => {
  const paginationParam = paginationParams[collectionType]
  const offsetValue = parameters && paginationParam && parameters[paginationParam] && parameters[paginationParam][0]
  return int(offsetValue)
}

export type ICollectionPaginationProps = {
  totalEpisodeSize: number
  collectionType: CollectionType
} & LocalizerProps & IStateProps

const PaginationWithContext = ({
  totalEpisodeSize,
  requestContext: { queryParameters, makeUrl },
  collectionType,
  getString,
  pageTitleId
}: ICollectionPaginationProps) => {
  // Only show pagination for Episodes and Bonus collections for now
  if (!['episodes', 'bonus'].includes(collectionType)) {
    return null
  }

  const linkMaker = (itemOffset: number, refMarkerSuffix: string) => {
    const get = {
      ...getCurrentOffsets(queryParameters),
      [paginationParams[collectionType]]: `${itemOffset}`,
    }
    const refTag = `dv_dp_${collectionType}_${refMarkerSuffix}`
    return makeUrl(detailPagePath(pageTitleId), {get, refTag})
  }

  const paginatorArgs = {
    currentOffset: getCollectionCurrentOffset(queryParameters, collectionType),
    totalItems: totalEpisodeSize,
    pageSize: DEFAULT_PAGE_SIZE,
    paginationHardLimit: DEFAULT_TOTAL_ITEMS_LIMIT,
    linkMaker,
    strings: {
      page: (pageNumber: string) => getString(StringId.DV_WEB_PAGINATION_PAGE, { pageNumber }),
      previous: getString(StringId.DV_WEB_PAGINATION_PREVIOUS),
      next: getString(StringId.DV_WEB_PAGINATION_NEXT),
    }
  }

  return (
    <Pagination paginator={paginator(paginatorArgs)} />
  )
}

const mapStateToProps = (state: IDetailPageState): IStateProps => ({
  requestContext: sanitizedRequestContextSelector(state),
  pageTitleId: state.pageTitleId
})

export const CollectionPagination = withLocalization(
  connect(mapStateToProps)(PaginationWithContext)
)
